import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import { LIST_VMS_QUERY_KEY } from '@/state/queries/vm-admin/use-list-vms';
import { GET_VM_DETAIL_QUERY_KEY } from '@/state/queries/vm-admin/use-get-vm-detail';

export const useStartVmMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (vmId: string) => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/vm/${vmId}/start`;
      return sendJSONRequest({ url, method: METHOD.POST, token: token ?? '' });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [LIST_VMS_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [GET_VM_DETAIL_QUERY_KEY] });
    },
  });
};
